import type { OrganizationType } from "../types/organization.types";

export const organizationTypeLabels: Record<OrganizationType, string> = {
  unknown: "Unknown",
  government: "Government",
  communityPartner: "Community Partner",
  merchant: "Merchant",
  city: "City",
};
